import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bannerActions, bannerSelectors } from "../ducks/banner";

export const useBanner = () => {
  const dispatch = useDispatch();

  const banners = useSelector(bannerSelectors.banners);

  useEffect(() => {
    dispatch(bannerActions.getBanners.started({}));
  }, []);

  return { banners };
};
